import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Search from "./pages/Search";
import CenterDetail from "./pages/CenterDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ClientDashboard from "./pages/ClientDashboard";
import ProviderDashboard from "./pages/ProviderDashboard";
import ProviderEnroll from "./pages/ProviderEnroll";
import AdminDashboard from "./pages/AdminDashboard";
import Agreement from "./pages/Agreement";
import ContractPreview from "./pages/ContractPreview";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/centers/:id" element={<CenterDetail />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/dashboard/client" element={<ClientDashboard />} />
                    <Route path="/dashboard/provider" element={<ProviderDashboard />} />
                    <Route path="/dashboard/admin" element={<AdminDashboard />} />
                    <Route path="/enroll" element={<ProviderEnroll />} />
                    <Route path="/agreement/:centerId" element={<Agreement />} />
                    <Route path="/centers/:id/contract-preview" element={<ContractPreview />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
                <Footer />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
